import type { Environment } from './environment.type';

// Microsoft Entra ID — DEV
// Tenant:      4f3526f9-97d6-412d-933a-4e30a73110f4
// Client ID:   24fdaadb-3da5-42a1-a724-851c690ebe7b (public — secret is in Secrets Manager)
// Admin group: AZ-MFR_PROD_ADMIN
//
// Redirect URIs registered on the Entra app — redirectUri MUST match one exactly:
//   https://dev.mfr.nbcuni.com/
//   http://localhost:4200
//   https://ssoapp.stg.inbcu.com/OAuthPlayground/case1A-callback.jsp
//
// API endpoint: https://wg37hhhfug.execute-api.us-west-2.amazonaws.com
//               (update to https://api.dev.mfr.nbcuni.com after DNS Phase 2)
// CloudFront:   d2z59mhzxsk85h.cloudfront.net → CNAME dev.mfr.nbcuni.com
//
// bypassAuth is intentionally absent — dev now performs a real Entra login.
const TENANT_ID = '4f3526f9-97d6-412d-933a-4e30a73110f4';
const APP_ORIGIN = 'https://dev.mfr.nbcuni.com';

export const environment: Environment = {
  production: false,
  name: 'dev',
  apiUrl: 'https://wg37hhhfug.execute-api.us-west-2.amazonaws.com',
  entraTenantId: TENANT_ID,
  entraClientId: '24fdaadb-3da5-42a1-a724-851c690ebe7b',
  entraAuthorizeUrl: `https://login.microsoftonline.com/${TENANT_ID}/oauth2/v2.0/authorize`,
  entraLogoutUrl:
    `https://login.microsoftonline.com/${TENANT_ID}/oauth2/v2.0/logout` +
    `?post_logout_redirect_uri=${encodeURIComponent(`${APP_ORIGIN}/`)}`,
  redirectUri: `${APP_ORIGIN}/`,
  entraScopes: 'openid profile email',
};
